import { Col, Row } from 'reactstrap';
import dayjs from 'dayjs';
import React from 'react';

import 'features/pending-timesheets/styles/approved-timesheet-details.scss';

export interface IApprovedTimesheetDetailsProps {
    approvedDate: Date;
    supervisorComments: string;
    textAlign: string;
}

const ApprovedTimesheetDetails = (props: IApprovedTimesheetDetailsProps): JSX.Element => {
    if (props.approvedDate === null || props.approvedDate === undefined) {
        return null;
    }

    return (
        <>
            <Row className={`w-100 font-weight-bold mb-1 approved-date ${props.textAlign}`}>
                <Col>Approved on {dayjs(props.approvedDate).format('YYYY-MM-DD')}</Col>
            </Row>
            <Row className={`w-100 font-weight-normal timesheet-comment mb-3 ${props.textAlign}`}>
                <Col>{props.supervisorComments}</Col>
            </Row>
        </>
    );
};

export default ApprovedTimesheetDetails;
